


<ng-template #template>
    <div class="modal-body position-relative pt-10 w-450px">
        <div class="position-absolute" style="top: 1rem; right: -2rem;">
            <i class="fa fa-times fa-lg text-danger cursor-pointer" (click)="cancel()"></i>
        </div>
        <div class="font-weight-bolder h2 mb-4 ml-20">{{ message }}</div>
        <div class="fontColor mb-10 ml-20">
            {{ submessage }}
        </div>
        <ng-content></ng-content>
        <div class="d-flex">
            <button class="btn btn-primary rounded-0 w-90px mx-6 ml-20" (click)="yes()">Ok</button>
        </div>
        <span class="position-absolute" style="top: 1rem; left: -3rem;">
            <img src="../../../.././../assets/common/images/modalpopup/WarningIcon.svg" style="width: 6rem;">

        </span>
    </div>
</ng-template>


